import { RotateCcw } from 'lucide-react';
import { formatFocusTime } from '../lib/catalog';

type FocusTimerProps = {
  remaining: number;
  total: number;
  running: boolean;
  onReset: () => void;
  onSetDuration: (seconds: number) => void;
};

const durations = [25 * 60, 50 * 60, 90 * 60];

export default function FocusTimer({ remaining, total, running, onReset, onSetDuration }: FocusTimerProps) {
  const circumference = 2 * Math.PI * 116;
  const ratio = total > 0 ? Math.max(0, Math.min(1, remaining / total)) : 0;
  const overtime = remaining <= 0;
  const stateLabel = overtime ? (running ? 'Overtime' : 'Overtime paused') : (running ? 'In session' : 'Ready');

  return (
    <div className={overtime ? 'focus-timer overtime' : 'focus-timer'}>
      <div className="duration-presets" role="group" aria-label="Focus duration">
        {durations.map((duration) => (
          <button
            className={total === duration ? 'duration-button active' : 'duration-button'}
            key={duration}
            onClick={() => onSetDuration(duration)}
            aria-pressed={total === duration}
          >
            {duration / 60}
          </button>
        ))}
      </div>

      <div className={overtime ? 'timer-dial overtime' : 'timer-dial'}>
        <svg viewBox="0 0 260 260" aria-hidden="true">
          <defs>
            <linearGradient id="progressStroke" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#55d8cf" />
              <stop offset="100%" stopColor="#c9f36c" />
            </linearGradient>
          </defs>
          <circle className="timer-track" cx="130" cy="130" r="116" />
          <circle
            className="timer-progress-ring"
            cx="130"
            cy="130"
            r="116"
            strokeDasharray={circumference}
            strokeDashoffset={circumference * (1 - ratio)}
          />
        </svg>
        <div className="timer-content" aria-live="polite">
          <strong>{overtime ? '+' : ''}{formatFocusTime(Math.abs(remaining))}</strong>
          <span className={`timer-state${running ? ' active' : ''}${overtime ? ' overtime' : ''}`}><i />{stateLabel}</span>
        </div>
        <button className="timer-reset" onClick={onReset} aria-label="Reset focus timer"><RotateCcw size={14} /></button>
      </div>
    </div>
  );
}
